/**
 * Supported UI locales for Cobstream i18n. Mirrors the shape of
 * `src/theme/themes.ts`: the concrete list lives here, native labels are
 * shown verbatim in the picker (never translated), and code that needs the
 * active locale reads it from `useLanguage()` / react-i18next.
 */
export type LanguageCode = 'en' | 'es';

export interface Language {
  code: LanguageCode;
  /** Native, untranslated label shown in the picker. */
  label: string;
}

export const LANGUAGES: readonly Language[] = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
] as const;

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export function isLanguageCode(value: unknown): value is LanguageCode {
  return typeof value === 'string' && LANGUAGES.some((l) => l.code === value);
}

/** Best-effort locale from the browser: es* → es, everything else → en. */
export function detectBrowserLanguage(): LanguageCode {
  if (typeof navigator === 'undefined') return DEFAULT_LANGUAGE;
  const raw = (navigator.language || '').toLowerCase();
  return raw.startsWith('es') ? 'es' : 'en';
}
